export const ROUTE_CONSTANTS = {
  COUNTY: '/county/profile',
  HOME: '/',
  INSURER: '/insurer/profile',
  REPORT_COVERAGE_COUNTY: '/report/coverage/county',
  REPORT_COVERAGE_PREMIUM: '/report/coverage/premium',
  REPORT_INSURERS_PREMIUM_COUNTY: '/report/insurers/premium/county',
  REPORT_INSURERS_PREMIUM_COVERAGE: '/report/insurers/premium/coverage',
  REPORT_PREMIUM_TREND: '/report/premium-trend',
  REPORT_TRANSACTION_TYPE_COMPARISON: `/report/transaction-type/comparison`,
  COVERAGECODE: '/coveragecode/profile',
};
